<template>
  <div
    class="card-chart"
  >
    <header>
      <h1>{{ title }}</h1>
    </header>
    <main>
      <slot/>
    </main>
  </div>
</template>

<script>
/**
   * 'CardChart' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'CardChart',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .card-chart {
    margin-bottom:20px;
    max-width: 100%;
    overflow: hidden;
    background-color: #ffffff;
    border-radius: $--border-radius-base;
    header {
      h1 {
        @include font-primary(18px, light);
        margin: 0;
      }
      padding: 20px;
    }
    main {
      position: relative;
      max-width: 100%;
      overflow: hidden;
      padding: 30px;
      height: 250px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/charts/card-chart.vue